module.exports = __webpack_public_path__ + "static/img/cube.fa8ca86.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/cube.png
// module id = 76Eg
// module chunks = 1